<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.234"
    height="17.224"
    viewBox="0 0 17.234 17.224"
  >
    <g transform="translate(-100.08 -100.302)">
      <path
        :fill="iconColor"
        class="a"
        d="M374.51,101.922l-1.339-1.339a1.017,1.017,0,0,0-1.4,0l-1.02,1.02-6.956,6.955-.022.024-.007.009-.012.017-.008.011-.01.016-.007.012-.012.026,0,.013-.006.017,0,.013,0,.02,0,.011v.005l-.45,2.685a.359.359,0,0,0,.414.414l2.685-.45h.005l.011,0,.02,0,.013,0,.017-.006.013,0,.026-.012.012-.007.016-.01.011-.008.017-.012.009-.007.024-.022,6.956-6.955,1.02-1.02a.992.992,0,0,0,0-1.4Zm-10.225,7.637,1.249,1.249-1.5.251Zm2,.98-1.727-1.727L371,102.365l1.727,1.727ZM374,102.817l-.766.766-.576-.576-1.151-1.151.766-.766a.281.281,0,0,1,.388,0L374,102.43a.274.274,0,0,1,0,.388Z"
        transform="translate(-257.487 0)"
      />
      <path
        :fill="iconColor"
        class="a"
        d="M114.76,207.3a.359.359,0,0,0-.359.359v7.6a.787.787,0,0,1-.786.786H101.584a.787.787,0,0,1-.786-.786V203.233a.787.787,0,0,1,.786-.786h6.891a.359.359,0,1,0,0-.718h-6.891a1.506,1.506,0,0,0-1.5,1.5v12.031a1.506,1.506,0,0,0,1.5,1.5h12.031a1.506,1.506,0,0,0,1.5-1.5v-7.6A.359.359,0,0,0,114.76,207.3Z"
        transform="translate(0 -99.242)"
      />
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'

  export default {
    name: 'EditIcon',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#383935'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 17.234px;
    height: 17.224px;
    transition: all 0.3s ease-in-out;
  }
  svg:hover {
    transform: rotate(45deg) scale(1.1);
  }
</style>
